import { Buffer } from "buffer";

export const dataUriEncodeSvg = (svg: string) => {
  const base64Str =
    typeof window !== "undefined" ? window.btoa(svg) : Buffer.from(svg).toString("base64");
  return `data:image/svg+xml;base64,${base64Str}`;
};
